import { useState, useRef } from "react";
import { FullHistoryRound } from "../../commander/Types";
import { useAppSelector } from "../../hooks";
import classes from "../../styles/History.module.css";
import Spin from "./Spin";
import { getClasses } from "../../utils";
import Spinner from "../Spinner";
import { EMPTY_TILE_ID } from "./Slot";

const Message: React.FC<{ visible: boolean; content?: string | null }> = ({
  visible,
  content,
}) => {
  if (!visible || !content) return null;

  return <div className={getClasses(classes, "round-message")}>{content} </div>;
};

const Round: React.FC<{ id: string; visible?: boolean }> = ({
  id,
  visible,
}) => {
  const [loaded, setLoaded] = useState(false);
  const { history } = useAppSelector((state) => state);
  const imagesCount = useRef(0);

  const data = history.rounds[id] as FullHistoryRound;
  // TODO do we neen this openedRounds to be part of the global state instead of a the component state
  const isVisible =
    typeof visible === "boolean"
      ? visible
      : history.openedRounds.find((r) => r === id);

  if (!isVisible || !data) return null;

  const views = data.views;
  const imagesToLoad = views.flat(2).filter((n) => n !== EMPTY_TILE_ID).length;
  const onLoad = () => {
    if (!loaded && imagesCount.current + 1 >= imagesToLoad) {
      setLoaded(true);
    }
    imagesCount.current += 1;
  };

  const hiddenClasss = data.views.length === 0 ? "hidden" : "";
  const errorClass = !!data.error ? "error" : "";
  const hasSpinner = (!!data.loading || !loaded) && !data.error;
  const loadedClass = loaded ? "loaded" : "";

  return (
    <div
      className={getClasses(
        classes,
        "cell",
        "details",
        loadedClass,
        errorClass
      )}
    >
      <Spinner size={35} visible={hasSpinner} full={true} />
      <Message visible={!!data.error} content={data.error?.message} />
      <div className={classes.outer} onLoad={onLoad} onError={onLoad}>
        <div className={getClasses(classes, "inner", hiddenClasss)}>
          <div className={classes.spins}>
            {views.map((_, i) => (
              <Spin key={`spin-${i}`} data={data} index={i} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Round;
